<template>
     <BaseContainer>
      <BaseContentContainer>
     
      <br><br><br>
     <div class="row align-items-center">

    <!-- Text -->
    <div class="col-md-6">
        <h1 class="display-6">Learning Pathways</h1>
        <div class="fs-5 mb-4 ">
         It is the standard pathway followed by our classes and tutoring lessons. It complements the 
      school teachings of the curriculum which includes (AQA, Cambridge, OCR, Pearson Edexcel etc) by customising the lessons to meet the individual needs of the students. Particulary the 
      worksheets and practicals are designed to build the knowledge by experimenting different concepts and technology. 
        </div>
      </div>
          <!-- Image -->
    <div class="col-md-6">
     <img
      :src="learningPathways"
      alt="Academy"
      class="normal-image"
      >
   
     
    </div></div>
        <h1 class="display-6">1. Curriculum-Based Learning</h1>
   <div class="fs-5 mb-4 ">
      It is the standard pathway followed by our classes and tutoring lessons. It complements the 
      school teachings of the curriculum which includes (AQA, Cambridge, OCR, Pearson Edexcel etc) by customising the lessons to meet the individual needs of the students. Particulary the 
      worksheets and practicals are designed to build the knowledge by experimenting different concepts and technology. 
  </div>
    <br> <br>
<!-- Bottom wide block -->

<div class="row justify-content-center g-3 " v-for="(object, index) in curriculum_based_data.slice().reverse()" :key="index">
    <div v-if="object.title.length === 1" class="col-12 col-md-6">

        <StackItem :object="{title:object.title[0]}"/>
    </div>
   
     <div v-else-if="object.title.length === 3">
     <div class="row justify-content-center g-2" >
     <div class="col-4 col-md-2">
        <StackItem :object="{title:object.title[0]}" />
     </div>
       <div class="col-4 col-md-2">
        <StackItem :object="{title:object.title[1]}" />
     </div>
      <div class="col-4 col-md-2">
        <StackItem :object="{title:object.title[2]}" />
     </div>
    </div>
       
      </div>
    
</div>

  <br> <br> <br>
     <h1 class="display-6">2. Inquiry-Based Learning</h1>
   <div class="fs-5 mb-4 ">
      This pathway encourages students to <b>investigates, builds, tests and reflects </b> on the choice of their topic. It runs
      all year around but student can work on it during the winter and summer holidays to extend their scope of computer science, that
      can be very helpful for their A-level studies and beyond.  
      It also contribute to their understanding of NEA and how to effectively approach and make confident decision about it.<br><br>
      The student can start with the <b>Technology Practicals</b>, which are shorter experiments, focused investigations where technology helps students understand a concept
      in the real-world scenario.
  </div>
  <br> <br>
  <div class="row justify-content-center g-3 " v-for="(object, index) in inquiry_based_data.slice().reverse()" :key="index">
    <div v-if="object.title.length === 1" class="col-12 col-md-8">

        <StackItem :object="{title:object.title[0]}"/>
    </div>
       <div v-else-if="object.title.length === 2">
     <div class="row justify-content-center g-2" >
          <div class="col-6 col-md-4">
              <StackItem :object="{title:object.title[0]}" />
          </div>
            <div class="col-6 col-md-4">
              <StackItem :object="{title:object.title[1]}" />
          </div>
          
    </div> 
    </div>
    
     <div v-else-if="object.title.length === 3">
     <div class="row justify-content-center g-2" >
     <div class="col-4 col-md-2">
        <StackItem :object="{title:object.title[0]}" />
     </div>
       <div class="col-4 col-md-2">
        <StackItem :object="{title:object.title[1]}" />
     </div>
      <div class="col-4 col-md-2">
        <StackItem :object="{title:object.title[2]}" />
     </div>
    </div>
       
      </div>

       <div v-else-if="object.title.length === 4">
     <div class="row justify-content-center g-2" >
     <div class="col-3 col-md-2">
        <StackItem :object="{title:object.title[0]}" />
     </div>
       <div class="col-3 col-md-2">
        <StackItem :object="{title:object.title[1]}" />
     </div>
      <div class="col-3 col-md-2">
        <StackItem :object="{title:object.title[2]}" />
     </div>
      <div class="col-3 col-md-2">
        <StackItem :object="{title:object.title[3]}" />
     </div>
    </div>
       
      </div>
    
</div>

  <br> <br> <br>
     <h1 class="display-6">3. Applied Learning</h1>
   <div class="fs-5 mb-4 ">
      This pathway encourages students to <b>extend and apply</b> learning and skills into broader technologies, 
      applications, practical problems and real-world computing contexts.
       
  </div>
  <br> <br>

  <div class="row justify-content-center g-3 " v-for="(object, index) in applied_learning_data.slice().reverse()" :key="index">
    <div v-if="object.title.length === 1" class="col-12 col-md-6">

        <StackItem :object="{title:object.title[0]}"/>
    </div>
   
     <div v-else-if="object.title.length === 3">
     <div class="row justify-content-center g-2" >
     <div class="col-4 col-md-2">
        <StackItem :object="{title:object.title[0]}" />
     </div>
       <div class="col-4 col-md-2">
        <StackItem :object="{title:object.title[1]}" />
     </div>
      <div class="col-4 col-md-2">
        <StackItem :object="{title:object.title[2]}" />
     </div>
    </div>
       
      </div>
    
</div>

<br> <br> <br>
   

    </BaseContentContainer>
</BaseContainer>
</template>
<script setup>
import learningPathways from '@/assets/images/learning_pathways/steps_12.jpg'
</script>
<script>
import BaseContainer  from '@/components/BaseContainer.vue';
import BaseContentContainer  from '@/components/BaseContentContainer.vue';
import StackItem from '@/components/StackItem.vue';

export default {
  name: 'CoursesView',
    components: {
      BaseContainer,BaseContentContainer,StackItem,
  },
  data() {
  return { curriculum_based_data : [
   {
      title: ['Curriculum-Based Learning'],
      description: ''
    },
     {
      title: ['Learning & Applying the Subject Content'],
      description: '',
    },
    {
      title: ["Reading", "Worksheets", "Practicals"],
      description: '',
     
    },
      {
      title: ['Diagnostic Assessment'],
      description: '',
     
    },
      {
      title: ['MCQs', "Short Tests", "Past Papers"],
      description: '',
     
    },
  ],
  inquiry_based_data : [
   {
      title: ['Inquiry-Based Learning'],
      description: ''
    },
     {
      title: ['Technology Practicals', 'Project-Based Learning'],
      description: '',
    },
    {
      title: ["VSC", "Networking", "Data Science", "Web Develop"],
      description: '',
     
    },
      {
      title: ["WebServer", "VPS", "IoT", "PyGame"],
      description: '',
     
    },
      {
      title: ["Linux (Ubuntu)", "Cyber Security"],
      description: '',
     
    },
  ],
   applied_learning_data : [
   {
      title: ['Applied Learning'],
      description: ''
    },
     {
      title: ['Linux Operating System'],
      description: '',
    },
    {
      title: ["Networking"],
      description: '',
     
    },
      {
      title: ["Cyber Security", "Web Develop", "Data Science"],
      description: '',
     
    },
      {
      title: ["Artificial Intelligence (AI)"],
      description: '',
     
    },
  ]
}// end of return
}
}
</script>


<style scoped>
.my-section {
   width: 100%;
  height: auto;
  object-fit: contain;
  background-image: url('@/assets/images/learning_pathways/learning_pathways_1.jpg');
  background-size: cover;
  background-position: center;
}

.normal-image {
  width: 100%;
  height: 500px;
  object-fit: contain;
  object-position: right;
}

</style>